import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Logo from "../assets/logo.png";
import { useState } from "react";
import Form from "react-bootstrap/Form";
import Alert from "@mui/material/Alert";
import { sqlAdjunto } from "../componentes/api.js";
import ReactPlayer from "react-player";

function SubirArchivos(props) {
  const [cargando, setCargando] = useState(false);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;</>;
  /*** Para muestra preliminar de los archivos ***** */
  const [file, setFile] = useState(null); //Contiene toda la info del archivo a grabar
  const [fileURL, setFileURL] = useState(null);
  const [fileType, setFileType] = useState("");
  const [video, setVideo] = useState(null);
  const [imagen, setImagen] = useState(null);
  const [audio, setAudio] = useState(null);
  const [tipoArchivo, setTipoArchivo] = useState(0);
  const [titulo, setTitulo] = useState(props.tituloAnexo);
  const [puedeGrabar, setPuedeGrabar] = useState(false);

  const handleChange = (event) => {
    setCargando(true);
    limpiar();
    setFile(event.files[0]);
    if (event.files[0]) {
      if (event.files[0].type === "video/mp4") {
        // video
        setTitulo("Video");
        setTipoArchivo(1);
        setVideo(URL.createObjectURL(event.files[0]));
        setCargando(false);
        setPuedeGrabar(true);
      } else if (event.files[0].type.startsWith("image")) {
        // imagen
        setTipoArchivo(2);
        let fileReader;
        if (event.files[0]) {
          fileReader = new FileReader();
          fileReader.onload = (e) => {
            const { result } = e.target;
            if (result) {
              setImagen(result);
            }
          };
          fileReader.readAsDataURL(event.files[0]);
        }
        setCargando(false);
        setPuedeGrabar(true);
      } else if (event.files[0].type.startsWith("application/pdf")) {
        // pdf
        setTitulo("PDF");
        setTipoArchivo(3);
        const selectedFile = event.files[0];
        const url = URL.createObjectURL(selectedFile);
        setFileURL(url);
        setFileType(selectedFile.type);
        setCargando(false);
        setPuedeGrabar(true);
      } else if (event.files[0].type.substring(0, 15) === "application/vnd") {
        // documento
        setTitulo("Documento");
        setTipoArchivo(3);
        const selectedFile = event.files[0];
        const url = URL.createObjectURL(selectedFile);
        setFileURL(url);
        setFileType(selectedFile.type);
        setCargando(false);
        setPuedeGrabar(true);
      } else if (event.files[0].type.startsWith("audio")) {
        // audio
        setTitulo("Audio");
        setTipoArchivo(4);
        setAudio(URL.createObjectURL(event.files[0]));
        setCargando(false);
        setPuedeGrabar(true);
      }
    } else {
      setCargando(false);
      props.mostrarMsg(["Por favor seleccione un Archivo!"]);
    }
  };

  const grabar = async () => {
    setCargando(true);
    setMostrarAlerta(false);
    try {
      /** Formateo los datos que enviaré */
      const formData = new FormData();
      formData.append("Ruta", props.Ruta);
      formData.append("Tabla", props.Tabla);
      formData.append("Campo", props.Campo);
      formData.append("Id", props.Id);
      formData.append("UsuarioReg", props.UsuarioReg);
      formData.append("idProyectoActividad", props.idProyectoActividad);
      formData.append(
        "idProyectoActividadDesarrollo",
        props.idProyectoActividadDesarrollo
      );
      formData.append("tipoArchivo", tipoArchivo);
      formData.append("idUsuario", props.idUsuario);
      formData.append("image", file);

      const response = await sqlAdjunto("setImagen", formData);
      props.mostrarMsg([response.data]);
      setFile(null);
      setCargando(false);
      if (props.consultarAnexos !== "") props.consultarAnexos();
      if (props.cerrarAlGrabar === true) salir();
    } catch (error) {
      setCargando(false);
      alert("ERROR", "Ocurrio un error al subir el Adjunto", error);
    }
  };

  const limpiar = () => {
    setFile(null);
    setVideo(null);
    setImagen(null);
    setFileURL(null);
    setFileType("");
    setAudio(null);
  };
  const salir = () => {
    limpiar();
    props.setVerVentanaSubir(false);
  };

  const visualizar = () => {
    if (tipoArchivo === 1) {
      //video
      return (
        <div className="player-wrapper">
          <ReactPlayer
            className="react-player"
            url={video}
            width="100%"
            height="100%"
            controls={true}
          />
        </div>
      );
    } else if (tipoArchivo === 2) {
      //imagen
      return (
        <div className="d-flex justify-content-center">
          <img src={imagen} className="img-fluid" alt="Imagen" />
        </div>
      );
    } else if (tipoArchivo === 3) {
      //documento
      if (fileType === "application/pdf") {
        return (
          <div className="mt-3 mb-3" style={{ width: "100%", height: "520px" }}>
            <p>Vista Preliminar del PDF</p>
            <iframe
              src={fileURL}
              style={{ width: "100%", height: "500px" }}
              title="Vista Preliminar del PDF"
            ></iframe>
          </div>
        );
      } else {
        //} else if (fileType.includes("officedocument")) {
        return (
          <div className="row mt-3 mb-3">
            <h5>¡ATENCION!</h5>
            <div className="form-text">
              La vista previa para este tipo de documento de Office no es
              pemitida. Sin embargo, puede ver el contido hacliendo Click sobre
              el siguiente link:
            </div>
            <a href={fileURL} download className="mt-2 mb-3">
              Descargar {fileType}
            </a>
            <hr />
          </div>
        );
      }
    } else if (tipoArchivo === 4) {
      //audio
      return (
        <div className="d-flex justify-content-center">
          <audio controls>
            <source src={audio} type="audio/mpeg" />
            Tu navegador no soporta el elemento de audio.
          </audio>
        </div>
      );
    }
  };

  return (
    <Modal
      show={props.verVentanaSubir}
      onHide={salir}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <img
          src={Logo}
          className="img-fluid"
          width="40px"
          height="120px"
          alt="logo"
        />
        <Modal.Title>
          {tab} Subir Archivos de {titulo}
          {cargando === true && (
            <div className="spinner-grow text-primary" role="status"></div>
          )}
        </Modal.Title>
      </Modal.Header>
      <form method="post" encType="multipart/form-data">
        <Modal.Body>
          {tipoArchivo !== 0 && visualizar()}
          <Form.Group
            controlId="formFileMultiple"
            method="POST"
            formEncType="multipart/form-data"
            className="mb-3"
          >
            <Form.Label>
              Por favor seleccione un archivo para subir al servidor!
            </Form.Label>
            <input
              className="form-control"
              type="file"
              name="archivo"
              id="archivo"
              onChange={(event) => handleChange(event.target)} //multiple
            />
          </Form.Group>
          {mostrarAlerta && (
            <Alert severity="error">Por favor escriba un Nombre!</Alert>
          )}

          <Modal.Footer>
            <Button variant="secondary" onClick={salir}>
              Salir
            </Button>
            <Button
              variant="primary"
              type="button"
              onClick={grabar}
              disabled={!puedeGrabar}
            >
              Grabar
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </form>
    </Modal>
  );
}
export default SubirArchivos;
